import { useParams } from 'react-router';

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_MANAGEMENT = '/management';
const ROOTS_USER = '/user';
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
};
export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    dashboard: path(ROOTS_DASHBOARD, ''),
  },
  user: {
    account: path(ROOTS_USER, '/account'),
  },
};

const accessToken = window.localStorage.getItem('accessToken');
const query = new URLSearchParams(window.location.search);
const isHasToken = query.has('token');
const token = isHasToken ? query.get('token') : accessToken;
window.localStorage.setItem('accessToken', token);

export const PATH_MANAGEMENT = {
  management: {
    root: path(ROOTS_MANAGEMENT, '/shop'),
    shops: path(ROOTS_MANAGEMENT, '/shop-all'),
    newShop: path(ROOTS_MANAGEMENT, '/shop/create'),
    editShop: {
      general: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=general`),
      logo: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=logo`),
      further: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=further`),
      address: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=address`),
      shopBankAccount: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=shopBankAccount`),
      geoJson: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=geoJson`),
      showTransactions: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=showTransactions`),
      BestSellingItems: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=bestSellingItems`),

      holidays: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=holidays`),
      workingHours: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=workingHours`),
      product: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=product`),
      increaseSales: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=increase-sales`),
      users: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=users`),
      roles: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=roles`),
      shopInvioce: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=invoice`),
      //shopInvioce: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=invoice&token=`),
      commentShop: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=comment`),
      discountShopCourier: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=get-courier-discount`),
      discountShop: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=discount-code`),
      shopBlockUser: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=shop-block-user`),
      accountUser: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=user-account`),
      WindowsProgram: (shopId) => path(ROOTS_MANAGEMENT, `/shop/edit/${shopId}?active=Windows-program`),
    },
    shopCategory: path(ROOTS_MANAGEMENT, '/shop-category'),
    shopCategoryHighlight: path(ROOTS_MANAGEMENT, '/shop-category-highlight'),
    mealTags: path(ROOTS_MANAGEMENT, '/shop-meal_tags'),
    geofance: path(ROOTS_MANAGEMENT, '/geofance'),
    closureShops: path(ROOTS_MANAGEMENT, '/closure-shops'),

    discountCode: {
      root: path(ROOTS_MANAGEMENT, '/discountCode'),
      create: path(ROOTS_MANAGEMENT, '/discountCode/create'),
      edit: (discountCodeId) => path(ROOTS_MANAGEMENT, `/discountCode/edit/${discountCodeId}`),
    },
    discountCodeShop: {
      create: (shopId) => path(ROOTS_MANAGEMENT, `/discountCode/${shopId}/create`),
    },
    qazvinProPlan: {
      root: path(ROOTS_MANAGEMENT, '/qazvin-pro-plan'),
      create: path(ROOTS_MANAGEMENT, '/qazvin-pro-plan/create'),
      edit: (planUuid) => path(ROOTS_MANAGEMENT, `/qazvin-pro-plan/edit/${planUuid}`),
    },
    qazvinProBenefitPool: {
      root: path(ROOTS_MANAGEMENT, '/qazvin-pro-benefit-pool'),
      create: path(ROOTS_MANAGEMENT, '/qazvin-pro-benefit-pool/create'),
      edit: (poolId) => path(ROOTS_MANAGEMENT, `/qazvin-pro-benefit-pool/edit/${poolId}`),
      codes: (poolId) => path(ROOTS_MANAGEMENT, `/qazvin-pro-benefit-pool/${poolId}/codes`),
      claims: (poolId) => path(ROOTS_MANAGEMENT, `/qazvin-pro-benefit-pool/${poolId}/claims`),
    },
    advertisement: {
      root: path(ROOTS_MANAGEMENT, '/advertisement'),
      create: path(ROOTS_MANAGEMENT, '/advertisement/create'),
      edit: (advertisementId) => path(ROOTS_MANAGEMENT, `/advertisement/edit/${advertisementId}`),
    },
    user: {
      root: path(ROOTS_MANAGEMENT, '/user'),
    },
    invoice: {
      root: path(ROOTS_MANAGEMENT, '/invoice'),
    },
    delay_invoice: {
      root: path(ROOTS_MANAGEMENT, '/delay-invoice'),
    },
    product_category: {
      root: path(ROOTS_MANAGEMENT, '/product-category'),
      create: path(ROOTS_MANAGEMENT, '/product-category/create'),
      edit: (productCategoryId) => path(ROOTS_MANAGEMENT, `/product-category/edit/${productCategoryId}`),
    },

    setting: {
      root: path(ROOTS_MANAGEMENT, '/setting'),
      create: path(ROOTS_MANAGEMENT, '/product-category/create'),
      edit: (productCategoryId) => path(ROOTS_MANAGEMENT, `/product-category/edit/${productCategoryId}`),
    },

    cashbackSegments: {
      root: path(ROOTS_MANAGEMENT, '/cashback-segments'),
    },

    shop_product_category: {
      root: path(ROOTS_MANAGEMENT, '/shop-product-category'),
      create: (shopId) => path(ROOTS_MANAGEMENT, `/shop-product-category/create/${shopId}`),
      edit: (shopId, shopProductCatgeoryId) =>
        path(ROOTS_MANAGEMENT, `/shop-product-category/${shopId}/edit/${shopProductCatgeoryId}`),
    },
    product: {
      root: path(ROOTS_MANAGEMENT, '/product'),
      create: (shopId) => path(ROOTS_MANAGEMENT, `/product/create/${shopId}`),
      edit: (shopId, productId) => path(ROOTS_MANAGEMENT, `/product/${shopId}/edit/${productId}`),
    },
    productStock: {
      root: (shopId, productId) => path(ROOTS_MANAGEMENT, `/shop/${shopId}/product/${productId}/stock`),
    },
    role: {
      root: path(ROOTS_MANAGEMENT, '/role'),
    },

    settlement: {
      root: path(ROOTS_MANAGEMENT, '/settlement'),
      details: (detailsId) => path(ROOTS_MANAGEMENT, `/settlement/details/${detailsId}`),
    },
    settlementAccumulative: {
      root: path(ROOTS_MANAGEMENT, '/settlement-accumulative'),
      details: (detailsId) => path(ROOTS_MANAGEMENT, `/settlement-accumulative/${detailsId}/details`),
    },

    transaction: {
      root: path(ROOTS_MANAGEMENT, '/transaction'),
    },

    walletPayment: {
      root: path(ROOTS_MANAGEMENT, '/wallet-payment'),
    },
    priceChange: path(ROOTS_MANAGEMENT, '/priceChange'),
    courier: {
      root: path(ROOTS_MANAGEMENT, '/courier'),
      editCourier: {
        general: (courierId) => path(ROOTS_MANAGEMENT, `/courier/edit/${courierId}?active=general`),
        further: (courierId) => path(ROOTS_MANAGEMENT, `/courier/edit/${courierId}?active=further`),
        courierBankAccount: (courierId) =>
          path(ROOTS_MANAGEMENT, `/courier/edit/${courierId}?active=courierBankAccount`),
        address: (courierId) => path(ROOTS_MANAGEMENT, `/courier/edit/${courierId}?active=address`),
        courierInvioce: (courierId) => path(ROOTS_MANAGEMENT, `/courier/edit/${courierId}?active=invoice`),
        courierTransactions: (courierId) =>
          path(ROOTS_MANAGEMENT, `/courier/edit/${courierId}?active=courierTransactions`),
        users: (courierId) => path(ROOTS_MANAGEMENT, `/courier/edit/${courierId}?active=users`),
      },
      create: path(ROOTS_MANAGEMENT, '/courier/create'),
    },

    comment: {
      root: path(ROOTS_MANAGEMENT, '/comment'),
    },

    activity: {
      root: path(ROOTS_MANAGEMENT, '/activity'),
      activity_info: (activityId) => path(ROOTS_MANAGEMENT, `/activity/${activityId}`),
    },
    credit: {
      root: path(ROOTS_MANAGEMENT, '/credit'),
    },
    taxes: {
      root: path(ROOTS_MANAGEMENT, '/taxes'),
    },
    shopInviocePrint: {
      view: (shopId, invioceId) => path(ROOTS_MANAGEMENT, `/shop/${shopId}/invoice/${invioceId}`),
    },
    reports:{
       root: path(ROOTS_MANAGEMENT, '/reports'),
       charityDonations: path(ROOTS_MANAGEMENT, '/reports/charity-donations'),
    },
      messenger:{
       root: path(ROOTS_MANAGEMENT, '/messenger'),
    }
  },
};
export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
